import { useState, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, Typography, FormControlLabel, Checkbox, useTheme } from '@mui/material';
import { ButtonBasic } from '../../components';

const ModalConfirmarCambiosContacto = ({show, hideModal, onSaveData, data, contactoOriginal}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const [cambiarCorreoPreServicios, setCambiarCorreoPreServicios] = useState(false);
    const handleClose = () => hideModal();

    const onSubmit = async() => {
        setIsLoading(true);
        await onSaveData({...data, cambiarCorreoPreServicios});
        setIsLoading(false);
        handleClose();
    }

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#90caf9' : '#000',fontWeight: 'bold'}} variant='h5'>
                        Confirmar cambios de datos de contacto
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e5e7eb'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{mt:2, mb:2}}>
                            <Typography variant='body1' sx={{textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000'}}>
                                ¿Está seguro que desea guardar los cambios realizados en los datos del contacto?
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center', mb: 1}}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={cambiarCorreoPreServicios}
                                        onChange={(e) => setCambiarCorreoPreServicios(e.target.checked)}
                                        sx={{
                                            color: isDarkMode ? '#64B5F6' : '#0364ff',
                                            '&.Mui-checked': {
                                                color: isDarkMode ? '#90caf9' : '#0364ff',
                                            },
                                        }}
                                    />
                                }
                                label="Cambiar también el correo en los pre-servicios asociados"
                                sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{mb:2}}>
                            <Typography variant='body2' sx={{textAlign: 'center', color: isDarkMode ? '#b0bec5' : 'gray'}}>
                                (Esta acción no se puede deshacer)
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e5e7eb'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalConfirmarCambiosContacto;